// ───── Taxi Fare Data ────────────────────────────────────────────────
// The following two objects contain fare data based on country.
// (All values are in US dollars.)
/*export const taxiStartingFees = {
    "Norway": 10.66,
    "Finland": 7.22,
    "Switzerland": 7.14,
    "Denmark": 6.91,
    "El Salvador": 6.50,
    "Cyprus": 5.94,
    "Sweden": 5.52,
    "Malta": 5.16,
    "Luxembourg": 5.16,
    "Italy": 5.16,
    "Belgium": 5.16,
    "Ireland": 5.11,
    "Austria": 5.05,
    "Venezuela": 5.00,
    "Lebanon": 5.00,
    "Germany": 4.64,
    "Israel": 4.53,
    "Greece": 4.13,
    "Japan": 3.92,
    "United States": 3.75,
    "Hong Kong (China)": 3.72,
    "United Kingdom": 3.72,
    "Netherlands": 3.71,
    "Spain": 3.68,
    "Portugal": 3.61,
    "Australia": 3.45,
    "Singapore": 3.38,
    "United Arab Emirates": 3.27,
    "Kuwait": 3.22,
    "Mauritius": 3.20,
    "Canada": 3.17,
    "Albania": 3.13,
    "Oman": 3.11,
    "South Korea": 3.10,
    "Slovakia": 3.09,
    "Lithuania": 3.09,
    "France": 3.09,
    "Estonia": 3.09,
    "Croatia": 3.09,
    "Hungary": 2.80,
    "Palestine": 2.79,
    "Saudi Arabia": 2.67,
    "Taiwan": 2.59,
    "Mexico": 2.43,
    "Latvia": 2.37,
    "Iraq": 2.27,
    "New Zealand": 2.26,
    "Qatar": 2.18,
    "Cuba": 2.14,
    "Peru": 2.14,
    "Nepal": 2.13,
    "Slovenia": 2.06,
    "Kosovo (Disputed Territory)": 2.06,
    "Czech Republic": 2.05,
    "Poland": 1.97,
    "Ukraine": 1.92,
    "Costa Rica": 1.78,
    "Azerbaijan": 1.76,
    "Serbia": 1.76,
    "Moldova": 1.72,
    "Kenya": 1.54,
    "Russia": 1.54,
    "Ecuador": 1.50,
    "Colombia": 1.45,
    "Bolivia": 1.44,
    "Uruguay": 1.38,
    "Argentina": 1.37,
    "China": 1.37,
    "Bosnia And Herzegovina": 1.32,
    "Bulgaria": 1.26,
    "Georgia": 1.26,
    "Kazakhstan": 1.17,
    "Belarus": 1.12,
    "Malaysia": 1.12,
    "South Africa": 1.08,
    "Thailand": 1.03,
    "Algeria": 1.03,
    "Brazil": 1.03,
    "Montenegro": 1.03,
    "Libya": 1.01,
    "North Macedonia": 1.01,
    "Nigeria": 0.89,
    "Turkey": 0.89,
    "Chile": 0.83,
    "India": 0.83,
    "Bangladesh": 0.81,
    "Philippines": 0.77,
    "Romania": 0.73,
    "Pakistan": 0.71,
    "Vietnam": 0.71,
    "Jordan": 0.70,
    "Morocco": 0.69,
    "Indonesia": 0.55,
    "Uzbekistan": 0.50,
    "Iran": 0.50,
    "Sri Lanka": 0.40,
    "Egypt": 0.40,
    "Tunisia": 0.28
};*/

export const taxiStartingFees = {
    NO: 10.66,
    FI: 7.22,
    CH: 7.14,
    DK: 6.91,
    SV: 6.50,
    CY: 5.94,
    SE: 5.52,
    MT: 5.16,
    LU: 5.16,
    IT: 5.16,
    BE: 5.16,
    IE: 5.11,
    AT: 5.05,
    VE: 5.00,
    LB: 5.00,
    DE: 4.64,
    IL: 4.53,
    GR: 4.13,
    JP: 3.92,
    US: 3.75,
    HK: 3.72, // Hong Kong SAR
    GB: 2.77, // This is in pounds
    NL: 3.71,
    ES: 3.14, // This is in euros
    PT: 3.61,
    AU: 3.45,
    SG: 3.38,
    AE: 3.27,
    KW: 3.22,
    MU: 3.20,
    CA: 3.17,
    AL: 3.13,
    OM: 3.11,
    KR: 3.10,
    SK: 3.09,
    LT: 3.09,
    FR: 2.64, // This is in euros
    EE: 3.09,
    HR: 3.09,
    HU: 2.80,
    PS: 2.79,
    SA: 2.67,
    TW: 2.59,
    MX: 2.43,
    LV: 2.37,
    IQ: 2.27,
    NZ: 2.26,
    QA: 2.18,
    CU: 2.14,
    PE: 2.14,
    NP: 2.13,
    SI: 2.06,
    XK: 2.06, // Kosovo (not officially ISO, XK is user-assigned)
    CZ: 2.05,
    PL: 1.97,
    UA: 1.92,
    CR: 1.78,
    AZ: 1.76,
    RS: 1.76,
    MD: 1.72,
    KE: 1.54,
    RU: 1.54,
    EC: 1.50,
    CO: 1.45,
    BO: 1.44,
    UY: 1.38,
    AR: 1.37,
    CN: 1.37,
    BA: 1.32,
    BG: 1.26,
    GE: 1.26,
    KZ: 1.17,
    BY: 1.12,
    MY: 1.12,
    ZA: 1.08,
    TH: 1.03,
    DZ: 1.03,
    BR: 1.03,
    ME: 1.03,
    LY: 1.01,
    MK: 1.01,
    NG: 0.89,
    TR: 0.89,
    CL: 0.83,
    IN: 0.83,
    BD: 0.81,
    PH: 0.77,
    RO: 0.73,
    PK: 0.71,
    VN: 0.71,
    JO: 0.70,
    MA: 0.69,
    ID: 0.55,
    UZ: 0.50,
    IR: 0.50,
    LK: 0.40,
    EG: 0.40,
    TN: 0.28
};
  
/*export const taxiPerKmRates = {
    "Switzerland": 4.28,
    "Luxembourg": 3.66,
    "Kuwait": 3.22,
    "Mauritius": 3.20,
    "Albania": 3.13,
    "El Salvador": 3.00,
    "Venezuela": 3.00,
    "Japan": 2.90,
    "Saudi Arabia": 2.67,
    "Belgium": 2.58,
    "Netherlands": 2.55,
    "Germany": 2.27,
    "Qatar": 2.18,
    "Denmark": 2.07,
    "Malta": 2.06,
    "Austria": 2.00,
    "Peru": 1.99,
    "Ireland": 1.96,
    "Costa Rica": 1.95,
    "Mexico": 1.94,
    "New Zealand": 1.92,
    "France": 1.90,
    "Cyprus": 1.83,
    "Sweden": 1.82,
    "Australia": 1.80,
    "United States": 1.74,
    "Nigeria": 1.69,
    "Colombia": 1.68,
    "Chile": 1.56,
    "Italy": 1.55,
    "Norway": 1.55,
    "Kenya": 1.54,
    "United Kingdom": 1.54,
    "Canada": 1.52,
    "Iraq": 1.52,
    "Lebanon": 1.50,
    "Ecuador": 1.50,
    "Uruguay": 1.49,
    "Finland": 1.44,
    "Bolivia": 1.44,
    "Jordan": 1.41,
    "Palestine": 1.40,
    "Hong Kong (China)": 1.35,
    "Spain": 1.32,
    "Czech Republic": 1.31,
    "Slovenia": 1.24,
    "Slovakia": 1.24,
    "Thailand": 1.18,
    "Hungary": 1.12,
    "Greece": 1.08,
    "Nepal": 1.06,
    "Montenegro": 1.03,
    "Lithuania": 1.03,
    "Croatia": 1.03,
    "South Africa": 1.03,
    "Libya": 1.01,
    "Argentina": 1.00,
    "Portugal": 0.93,
    "Serbia": 0.88,
    "Kosovo (Disputed Territory)": 0.88,
    "Brazil": 0.86,
    "Israel": 0.84,
    "Poland": 0.84,
    "Estonia": 0.83,
    "Bosnia And Herzegovina": 0.79,
    "Oman": 0.78,
    "Latvia": 0.77,
    "Taiwan": 0.76,
    "Singapore": 0.74,
    "Malaysia": 0.73,
    "Romania": 0.73,
    "Georgia": 0.72,
    "Morocco": 0.69,
    "Bulgaria": 0.68,
    "Kazakhstan": 0.68,
    "United Arab Emirates": 0.68,
    "Turkey": 0.64,
    "Vietnam": 0.63,
    "Azerbaijan": 0.59,
    "North Macedonia": 0.59,
    "South Korea": 0.59,
    "Pakistan": 0.53,
    "Cuba": 0.50,
    "Bangladesh": 0.41,
    "Algeria": 0.37,
    "Indonesia": 0.37,
    "China": 0.34,
    "Ukraine": 0.34,
    "Sri Lanka": 0.33,
    "Tunisia": 0.31,
    "Russia": 0.31,
    "Belarus": 0.30,
    "Uzbekistan": 0.30,
    "Iran": 0.30,
    "Egypt": 0.30,
    "India": 0.29,
    "Moldova": 0.26,
    "Philippines": 0.26
};*/

export const taxiPerKmRates = {
    CH: 4.28,
    LU: 3.66,
    KW: 3.22,
    MU: 3.20,
    AL: 3.13,
    SV: 3.00,
    VE: 3.00,
    JP: 2.90,
    SA: 2.67,
    BE: 2.58,
    NL: 2.55,
    DE: 2.27,
    QA: 2.18,
    DK: 2.07,
    MT: 2.06,
    AT: 2.00,
    PE: 1.99,
    IE: 1.96,
    CR: 1.95,
    MX: 1.94,
    NZ: 1.92,
    FR: 1.62, // This is in euros
    CY: 1.83,
    SE: 1.82,
    AU: 1.80,
    US: 1.74,
    NG: 1.69,
    CO: 1.68,
    CL: 1.56,
    IT: 1.55,
    NO: 1.55,
    KE: 1.54,
    GB: 1.15, // This is in pounds
    CA: 1.52,
    IQ: 1.52,
    LB: 1.50,
    EC: 1.50,
    UY: 1.49,
    FI: 1.44,
    BO: 1.44,
    JO: 1.41,
    PS: 1.40,
    HK: 1.35, // Hong Kong SAR
    ES: 1.13, // This is in euros
    CZ: 1.31,
    SI: 1.24,
    SK: 1.24,
    TH: 1.18,
    HU: 1.12,
    GR: 1.08,
    NP: 1.06,
    ME: 1.03,
    LT: 1.03,
    HR: 1.03,
    ZA: 1.03,
    LY: 1.01,
    AR: 1.00,
    PT: 0.93,
    RS: 0.88,
    XK: 0.88, // Kosovo (user-assigned)
    BR: 0.86,
    IL: 0.84,
    PL: 0.84,
    EE: 0.83,
    BA: 0.79,
    OM: 0.78,
    LV: 0.77,
    TW: 0.76,
    SG: 0.74,
    MY: 0.73,
    RO: 0.73,
    GE: 0.72,
    MA: 0.69,
    BG: 0.68,
    KZ: 0.68,
    AE: 0.68,
    TR: 0.64,
    VN: 0.63,
    AZ: 0.59,
    MK: 0.59,
    KR: 0.59,
    PK: 0.53,
    CU: 0.50,
    BD: 0.41,
    DZ: 0.37,
    ID: 0.37,
    CN: 0.34,
    UA: 0.34,
    LK: 0.33,
    TN: 0.31,
    RU: 0.31,
    BY: 0.30,
    UZ: 0.30,
    IR: 0.30,
    EG: 0.30,
    IN: 0.29,
    MD: 0.26,
    PH: 0.26
};
